// extracted by mini-css-extract-plugin
export default {"card":"selectMultipleProblemCard_card__5O90g","selectedCard":"selectMultipleProblemCard_selectedCard__EfgEI"};